export const CLOSE = 'CLOSE'
export const CLOSE_LOADED = 'CLOSE_LOADED'
export const CLOSE_WITH_LOADER = 'CLOSE_WITH_LOADER'
export const OPEN = 'OPEN'



export const CONTENT = 'CONTENT'
export const CIRCLE = 'CIRCLE'
export const LOAD_CONTENT = 'LOAD_CONTENT'
export const BACKGROUND = 'BACKGROUND'